export const defaultFilters = {
  query: '',
  store: false,
  terminal: false,
  pickup: false,
  fitting: false,
  returns: false,
  cardPay: false,
  dayAndNight: false,
  withoutPrepay: false,
  withoutQrCode: false,
};
